import { z } from 'zod';
import {
  FinanceStructureSchema,
  DeskingSaleDetailsPartSchema,
  DeskingEquipmentFormPartSchema,
} from 'modules/desking/shared';
import { RatePresentationType, ContactType, BrandingType } from '../types';

const proposalSettingsSchema = z.object({
  contact: z.nativeEnum(ContactType),
  branding: z.nativeEnum(BrandingType),
  ratePresentation: z.nativeEnum(RatePresentationType),
});

const customerSchema = z.object({
  name: z.string().optional(),
  phone: z.string().optional(),
  email: z.string().optional(),
  contact: z.string().optional(),
});

const actionsSchema = z.object({
  isUseDefaultTermsAndConditions: z.boolean(),
  ccToDealer: z.boolean(),
  additionalInfo: z.string(),
});

const submissionSchema = z.object({
  selectedSubmissionId: z.string().optional(),
  maxApprovalAmount: z.number().optional(),
});

const financeProgramDescriptionSchema = z.object({
  apiValue: z.string().optional(),
  editorValue: z.any().optional(),
});

const displaySettingsSchema = z.object({
  productPrice: z.boolean(),
  productDetails: z.boolean(),
  showLenderLogo: z.boolean(),
  showLenderName: z.boolean(),
  showBestOptions: z.boolean(),
  showInterestRate: z.boolean(),
  excludeEquipmentSales: z.boolean(),
  shouldRedirectToOCA: z.boolean(),
  lenderProfileId: z.string().nullable(),
  showFinanceProgramDescription: z.boolean(),
});

export const lenderDeskingDataShema = z
  .object({
    actions: actionsSchema,
    customer: customerSchema,
    submission: submissionSchema,
    displaySettings: displaySettingsSchema,
    lenderDescription: z.string(),
    decision: z.string().optional(),
    proposalSettings: proposalSettingsSchema,
    financeProgramDescription: financeProgramDescriptionSchema,
    contingencies: z.array(z.object({ label: z.string(), value: z.string() })),
  })
  .and(DeskingSaleDetailsPartSchema)
  .and(DeskingEquipmentFormPartSchema)
  .and(FinanceStructureSchema);
